module.exports = __webpack_public_path__ + "static/186546449.4ddb974c.jpg";